import { useGetExactSearchQuery, useGetSearchQuery } from 'hooks/queries/search';
import { useSearchParams } from 'react-router-dom';
import useCommonStore from 'store/useCommonStore';
import styled from 'styled-components';
import { StickySectionHeaderRow } from 'styles/styled-components/section';
import style from 'styles/styled-components/style';

const SearchStateRow = () => {
	const [search_params] = useSearchParams();
	const keyword_query = search_params.get('keyword') ?? '';

	const { search_filter } = useCommonStore();

	const { data: exact_search_data = null } = useGetExactSearchQuery(keyword_query);
	const { data: search_data = null } = useGetSearchQuery(keyword_query);

	const text = () => {
		if (keyword_query === null || keyword_query.trim() === '') return '검색어 입력 전 ';

		return (
			<>
				<span>&#39;{keyword_query}&#39;</span>의 연관 계정{' '}
				{search_data && exact_search_data
					? search_filter.code === 'total'
						? search_data?.pages[0].count + exact_search_data?.count
						: search_data?.pages[0].count
					: '-'}
				건이 발견 되었습니다.
			</>
		);
	};

	return (
		<StickySectionHeaderRow _padding="17.5px 32px" sticky_top="154px" z_index={1}>
			<style.Grid flex="start">
				<StateText>{text()}</StateText>
			</style.Grid>
		</StickySectionHeaderRow>
	);
};

const StateText = styled.p`
	${({ theme }) => theme.typo.body.span_bold};

	& > span {
		color: ${({ theme }) => theme.colors.primary.primary50_key};
	}
`;

export default SearchStateRow;
